import { Fragment, useState } from "react";
import GetReadyCountDown from './getReadyCountdown';
import CountDown from "./countdown";
import { genorateTable, genorateTables, genorateExcersices } from "./ttmath";
import  Question  from "./Question";
import Scores from "./Scores";
import ResultsStates from "./classes/ResultsStates";
import Results from "./Results";

const Exercise=({urlParams}: {urlParams:Record <string, any>})=>{

	const exercise = urlParams.get('exercise')//2to5 6to9 2to9 2to12
	let from = parseInt(exercise.split('to')[0]);
	let to = parseInt(exercise.split('to')[1]);
	//var state = ['getReady', 'runningExcersice', 'finished'];
	const [gameState, setGameState] = useState<string>('getReady');
	const [exercisesArr, setExercisesArr] = useState( genorateExcersices(from, to, 360));
	const [resultsStates, setresultsStates] = useState<ResultsStates>(new ResultsStates());
	var [activeQuesitonIndex, setActiveQuesitonIndex] = useState<number>(0);
	const [incorrectAnswers, setIncorrectAnswers] = useState<string[]>([]);


	function handleStateChange(gameState:string) {
		setGameState(gameState);
		console.log(gameState);
	}
	function handleUserSubmit(inputValue:string) {
		var computedResult:string = exercisesArr[activeQuesitonIndex].split('=')[1]
		var userResult:string = inputValue;
		if (computedResult === userResult) {
			resultsStates.increaseCorrect();
		}
		else{
			resultsStates.increaseInCorrect();
			setIncorrectAnswers([...incorrectAnswers, exercisesArr[activeQuesitonIndex] + ' not: ' + `"${userResult}"`])
			
			console.log(incorrectAnswers);
		}
		
		setresultsStates(new ResultsStates(resultsStates));
		console.log(resultsStates);
		setActiveQuesitonIndex(++activeQuesitonIndex);


	}

	function finishHandler() {
		setGameState('finished');
	}

	if (gameState === 'finished') {
		
	}
	
	//var arr = genorateExcersices(from, to, 44);
	//var tasks = [];//arr.join('<br />');
	console.log(exercisesArr);

	return <>
		{gameState != 'finished' &&
			<a href="./" className="btn btn-outline-danger mb-4 mt-3" style={{marginLeft:'30px'}}>cancel</a>
		}
		<div>
			{gameState === 'getReady' &&
				<h2 className="text-center" style={{color:'FireBrick'}}>GET READY!</h2>
			}
			{gameState === 'getReady' &&
				<Question handleUserSubmit={(inputValue:string)=>handleUserSubmit(inputValue)} exercisesArr={exercisesArr} activeQuesitonIndex={activeQuesitonIndex} gameState = {gameState} />
			}
			{gameState ==='getReady' &&
				<GetReadyCountDown key='GetReadyCountDown' stateChangeHandler={()=>{handleStateChange('runningExercise')}} />
			}
			{gameState === 'runningExercise' &&
				<Question handleUserSubmit={ (inputValue:string) => handleUserSubmit(inputValue)} exercisesArr={exercisesArr} activeQuesitonIndex={activeQuesitonIndex} gameState = {gameState} />
			}
			{gameState === 'runningExercise' &&
				<CountDown key='CountDown' finishHandler ={()=> {finishHandler()}}/>
			}
			{gameState === 'finished' &&
				<Results exercise={exercise} resultsStates={resultsStates} incorrectAnswers={incorrectAnswers} exercisesArr = {exercisesArr} />
			}
			{gameState !== 'finished' &&
				<Scores resultsStates={resultsStates} />
			}
		</div>
	</>;
};

export default Exercise;
